import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { QuestionComponent } from '../question.component';
import { QuestionResponse, QuestionAnswerInstanceResponse, SurveyStateService, AnswerOptionResponse, SelectedOptionRequest } from '../../public-api';

@Component({
    selector: 'app-multi-select-series-question',
    templateUrl: './multi-select-series-question.component.html',
    styleUrls: ['./multi-select-series-question.component.scss'],
    standalone: false
})
export class MultiSelectSeriesQuestionComponent implements OnInit, OnDestroy, QuestionComponent {

  @Input() questionData: QuestionResponse;
  @Input() questionAnswerInstanceList: QuestionAnswerInstanceResponse[];
  @Input() messageService: MessageService;
  @Input() surveyStateService: SurveyStateService;
  @Input() readonly: boolean;

  selectedAnswerOptionIdList = [];
  orderedColumnNames = [];
  orderedRowNames = [];
  showComponent = false;


  private answerSavedSubscription: Subscription;
  constructor() { }

  ngOnInit() {
    this.prepareData();
    this.showComponent = this.surveyStateService.checkVisibilityCondition(this.showComponent, this.questionData.dependsOnAnswerOptionIdCollection, this.questionData.id);
    this.answerSavedSubscription = this.surveyStateService.answerSaved.subscribe(
      data => {
        if (data.successStatus) {
          this.showComponent = this.surveyStateService.checkVisibilityCondition(this.showComponent, this.questionData.dependsOnAnswerOptionIdCollection, this.questionData.id);
          if (this.showComponent === false) {
            this.selectedAnswerOptionIdList = [];
          }
        }
      });
  }

  prepareData() {
    this.selectedAnswerOptionIdList = this.questionAnswerInstanceList.map(a => a.answerOptionSelectedId);
    this.questionData.answerCollection = this.questionData.answerCollection.sort((a, b) =>
      a.matrixRowId - b.matrixRowId || a.matrixColumnId - b.matrixColumnId);

    this.orderedColumnNames = this.questionData.matrixColumnConfigurationCollection.sort(colConfig => colConfig.matrixColumnId).map(colConfig => colConfig.matrixColumnText)

    // this.orderedColumnNames = this.questionData.answerCollection.map(item => item.matrixColumnText)
    //   .filter((value, index, self) => self.indexOf(value) === index);
    
    this.orderedRowNames = this.questionData.matrixRowConfigurationCollection.sort(rowConfig => rowConfig.matrixRowId).map(colConfig => colConfig.matrixRowText)
    // this.orderedRowNames = this.questionData.answerCollection.map(item => item.matrixRowText)
    //   .filter((value, index, self) => self.indexOf(value) === index);
  }

  getOptionsForCell(matrixRowId, matrixColumnId): AnswerOptionResponse {
    return this.questionData.answerCollection.filter(a => a.matrixRowId === matrixRowId && a.matrixColumnId === matrixColumnId)[0].answerOptionCollection[0];
  }

  ngOnDestroy(): void {
    this.answerSavedSubscription.unsubscribe();
  }

  toggleSelected(isChecked) {
    this.surveyStateService.saveQuestionAnswersCommand(
      this.selectedAnswerOptionIdList.map(a => ({ AnswerOptionId: a, FreeText: null } as SelectedOptionRequest)),
      this.questionData.id);
  }
}
